import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MenProcessComponent } from './menprocess.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [MenProcessComponent],
  exports: [
    MenProcessComponent
  ],
  providers: [
  ]
})
export class MenProcessModule { }
